import { ThemeStyles } from '@honda-canada/design-system-react';
import css from '@styled-system/css';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('Wrapper')(
  css({
    px: ['s', 's', '40px'],
    py: 'l',
    display: 'flex',
    flexDirection: ['column', 'column', 'row'],
    alignItems: ['start', 'start', 'center'],
    gap: ['10px', '10px', '48px'],
  }),
);

themeStyles.addBaseStyles('CTA')(({ disabled }) =>
  css({
    display: 'flex',
    alignItems: 'center',
    width: 'max-content',
    pb: 'xs',
    opacity: disabled ? 0.4 : 1,

    '&:hover': {
      borderColor: disabled && 'transparent',
      cursor: disabled && 'default',
    },
  }),
);

themeStyles.addBaseStyles('ToastLink')(({ theme }) =>
  css({
    color: theme.colors.black,
    fontFamily: 'bold',
    fontSize: 'sm',
  }),
);

themeStyles.addBaseStyles('IconWrapper')(
  css({
    my: 'auto',
    width: '32px',
    flexShrink: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  }),
);

export default themeStyles;
